import React, { useState } from 'react';
import './App.css'; 
import GaleriaMasonry from './components/GaleriaMasonry';

function App() {
  // Estados do formulário
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [localEvento, setLocalEvento] = useState('');
  const [dataEvento, setDataEvento] = useState('');
  const [equipamento, setEquipamento] = useState('');
  const [tipoEvento, setTipoEvento] = useState('');
  const [numeroConvidados, setNumeroConvidados] = useState('');
  const [mensagem, setMensagem] = useState('');

  const limparFormulario = () => {
    setNome("");
    setEmail("");
    setTelefone("");
    setLocalEvento("");
    setDataEvento("");
    setEquipamento("");
    setTipoEvento("");
    setNumeroConvidados("");
    setMensagem("");
  };

  // Gera link do WhatsApp
  const gerarMensagemWhatsApp = () => {
    const mensagemFormatted =
      `*Mensagem*: ${mensagem}\n\n` +
      `*Nome*: ${nome}\n` +
      `*E-mail*: ${email}\n` +
      `*Telefone*: ${telefone}\n` +
      `*Local do Evento*: ${localEvento}\n` +
      `*Data do Evento*: ${dataEvento}\n` +
      `*Equipamento Desejado*: ${equipamento}\n` +
      `*Tipo de Evento*: ${tipoEvento}\n` +
      `*Número de Convidados*: ${numeroConvidados}`;

    const mensagemCodificada = encodeURIComponent(mensagemFormatted);
    return `https://wa.me/5521992801818?text=${mensagemCodificada}`;
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    alert("Mensagem enviada, logo retornaremos o contato via WhatsApp!");
    window.open(gerarMensagemWhatsApp(), '_blank');
    limparFormulario();
  };

  // Gerar o array com os caminhos das mídias locais (foto10.jpg a foto65.jpg)
  const fotosLocais = [];
  for (let i = 10; i <= 65; i++) {
    fotosLocais.push({
      id: i,
      url: `/imagens/foto${i}.jpg`,
      titulo: `Registro #${i}`,
      tipo: 'foto'
    });
  }

return (
  <React.Fragment>
    {/* Cabeçalho */}
    <header className="header-container sticky top-0 z-50">
      <div className="header-bg-laranja py-3 px-4">
        <div className="container mx-auto flex items-center justify-between">
          {/* Logo */}
          <div className="logo-container">
            <img src="/logo.png" alt="Logo" className="logo h-10 w-auto object-contain" />
          </div>

          {/* Menu de Navegação */}
          <nav>
            <ul className="nav-list">
              <li><a href="#fotocabine" className="hover:text-white">A Fotcabine</a></li>
              <li><a href="#sobre" className="hover:text-white">Sobre Nós</a></li>
              <li><a href="#equipamentos" className="hover:text-white">Equipamentos</a></li>
              <li><a href="#galeria" className="hover:text-white">Galeria</a></li>
              <li><a href="#contato" className="hover:text-white">Contato</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>

      {/* Seção A Fotocabine */}
      <section id="fotocabine" className="py-20 bg-gray-100 text-black">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl mb-6 text-laranja">A Fotcabine</h2>
          <p className="text-justify max-w-3xl mx-auto">
            Desde 2014 no mercado a Fotcabine teve o privilégio de estar presente nos momentos mais emocionantes como casamentos, formaturas, 15 anos e eventos corporativos de vários tipos. Temos orgulho em dizer que nunca deixamos de cumprir nossos contratos. Com equipamentos tradicionais como a CABINE DE FOTOS, sofisticados como o ESPELHO MÁGICO e como não poderia faltar os modernos como PLATAFORMA ou MOBILEBOOTH, estamos sempre criando recordações para uma vida toda, pois levamos para sua festa Mais que uma lembrança!
          </p>
        </div>
      </section>

      {/* Seção Sobre */}
      <section id="sobre" className="py-20 bg-preto text-white">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl mb-6 text-laranja">Sobre Nós</h2>
          <p className="text-justify max-w-3xl mx-auto">
            Somos a Família Teixeira: Felipe, Isis, Miguel, Nicolas e Vinicius.
            Quando começamos a empresa ainda éramos apenas 4, mas logo chegou o quinto integrante!!!
            Começamos com zero experiência no assunto e com o tempo fomos aprendendo tudo que podíamos e conseguimos sair de uma Cabine de Fotos para 8 equipamentos! E agora o legado está sendo passado, nossos filhos já estão executando eventos sozinhos e assim estamos até hoje. Nessa caminhada desde 2014 tivemos ajuda de muitos amigos para cumprir os compromissos, e somos muito gratos a eles e toda nossa família que sempre nos apoiou quando precisamos.
          </p>
        </div>
      </section>

{/* Seção Equipamentos - Layout Tradicional com Flexbox Responsivo */}
<section id="equipamentos" className="bg-slate-100 py-16 md:py-24 border-y border-slate-200">
  <div className="container mx-auto text-center px-4">
    <h2 className="text-3xl md:text-5xl font-black mb-4 text-slate-900 tracking-tight">
      Nossos Equipamentos
    </h2>
    <p className="text-slate-700 font-medium max-w-2xl mx-auto mb-10 md:mb-14 text-base leading-relaxed">
      Especialistas em eternizar momentos. Escolha a opção perfeita para a sua festa.
    </p>

    {/* Container principal usando Flexbox em vez de Grid para garantir a quebra no mobile */}
    <div className="flex flex-wrap justify-center -mx-4 max-w-7xl mx-auto">
      
      {[
        { id: '1', nome: 'Cabine de Fotos', desc: 'A tradicional cabine fechada que garante privacidade e muita diversão, entregando fotos impressas personalizadas na hora.', equip: 'Cabine de Fotos' },
        { id: '2', nome: 'Tótem Retrô', desc: 'Design vintage elegante em madeira nobre, ideal para compor a decoração de casamentos e eventos sofisticados.', equip: 'Tótem Retrô' },
        { id: '3', nome: 'Plataforma 360°', desc: 'Vídeos incríveis em slow motion gerados em tempo real com efeitos visuais e música para compartilhamento imediato.', equip: 'Plataforma 360' },
        { id: '4', nome: 'Espelho Mágico', desc: 'Espelho touchscreen interativo em tamanho real com animações dinâmicas e opção de assinar a foto na própria tela.', equip: 'Espelho Mágico' },
        { id: '5', nome: 'VídeoBook', desc: 'Grave depoimentos emocionantes e divertidos dos seus convidados em alta resolução de áudio e vídeo.', equip: 'VídeoBook' },
        { id: '6', nome: 'GuestBook', desc: 'Álbum físico personalizado onde os convidados colam a cópia da foto impressa e deixam recados carinhosos.', equip: null },
        { id: '7', nome: 'Tótem 32"', desc: 'Super tela de 32 polegadas com ótima visualização para fotos em grandes grupos e excelente destaque na festa.', equip: null },
        { id: '8', nome: 'Cabine Vogue', desc: 'Túnel de iluminação de alta intensidade em estilo passarela para registros fotográficos e vídeos profissionais.', equip: null },
        { id: '9', nome: 'Tótem IA / Mobile', desc: 'Inteligência Artificial para troca de cenários virtuais, criação de avatares interativos e envio rápido direto ao celular.', equip: 'MobileBooth' },
      ].map((item) => (
        <div key={item.id} className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
          <div className="w-full bg-white rounded-2xl overflow-hidden shadow-md border border-slate-200 flex flex-col justify-between text-left h-full">
            <div>
              <div className="w-full h-64 sm:h-80 overflow-hidden bg-slate-200 relative">
                <img 
                  src={`/imagens/equipamento${item.id}.jpg`} 
                  alt={item.nome} 
                  className="w-full h-full object-cover block"
                  onError={(e) => {
                    if (!e.target.dataset.triedUpper) {
                      e.target.dataset.triedUpper = 'true';
                      e.target.src = `/imagens/EQUIPAMENTO${item.id}.jpg`;
                    }
                  }}
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-laranja uppercase mb-3">{item.nome}</h3>
                <p className="text-slate-800 font-medium text-base leading-relaxed">{item.desc}</p>
              </div>
            </div>
            <div className="p-6 pt-0">
              <a 
                href="#contato" 
                onClick={() => item.equip && setEquipamento(item.equip)} 
                className="inline-block text-base font-bold text-slate-900 hover:text-laranja transition-colors"
              >
                Solicitar Orçamento &rarr;
              </a>
            </div>
          </div>
        </div>
      ))}

    </div>
  </div>
</section>

      {/* Seção Galeria Masonry Dinâmica */}
      <section id="galeria">
        <GaleriaMasonry midias={fotosLocais} />
      </section>

      {/* Seção Contato */}
      <section id="contato" className="py-20 bg-white text-black">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl mb-6 text-laranja">Contato</h2>

          <form onSubmit={handleSubmitForm} className="max-w-2xl mx-auto mt-8">
            {/* Nome + Email */}
            <div className="row mb-4">
              <div className="col">
                <label htmlFor="nome" className="block text-left">Nome</label>
                <input
                  type="text"
                  id="nome"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  placeholder="Seu nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  required
                />
              </div>
              <div className="col">
                <label htmlFor="email" className="block text-left">E-mail</label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  placeholder="Seu e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* Telefone + Local + Data */}
            <div className="row mb-4">
              <div className="col">
                <label htmlFor="telefone" className="block text-left">Telefone</label>
                <input
                  type="text"
                  id="telefone"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  placeholder="Seu telefone"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                  required
                />
              </div>
              <div className="col">
                <label htmlFor="local_evento" className="block text-left">Local do evento</label>
                <input
                  type="text"
                  id="local_evento"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  placeholder="Local do evento"
                  value={localEvento}
                  onChange={(e) => setLocalEvento(e.target.value)}
                  required
                />
              </div>
              <div className="col">
                <label htmlFor="data_evento" className="block text-left">Data do evento</label>
                <input
                  type="date"
                  id="data_evento"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  value={dataEvento}
                  onChange={(e) => setDataEvento(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* Equipamento + Tipo de Evento + Convidados */}
            <div className="row mb-4">
              <div className="col">
                <label htmlFor="equipamento" className="block text-left">Equipamento Desejado</label>
                <select
                  id="equipamento"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  value={equipamento}
                  onChange={(e) => setEquipamento(e.target.value)}
                  required
                >
                  <option value="">Selecione um equipamento</option>
                  <option value="Cabine de Fotos">Cabine de Fotos</option>
                  <option value="Tótem Retrô">Tótem Retrô</option>
                  <option value="Espelho Mágico">Espelho Mágico</option>
                  <option value="Plataforma 360">Plataforma 360</option>
                  <option value="VídeoBook">VídeoBook</option>
                  <option value="GuestBook">GuestBook</option>
                  <option value="Tótem 32">Tótem 32"</option>
                  <option value="Cabine Vogue">Cabine Vogue</option>
                  <option value="MobileBooth">MobileBooth</option>
                </select>
              </div>

              <div className="col">
                <label htmlFor="tipo_evento" className="block text-left">Tipo de evento</label>
                <select
                  id="tipo_evento"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  value={tipoEvento}
                  onChange={(e) => setTipoEvento(e.target.value)}
                  required
                >
                  <option value="">Selecione o tipo de evento</option>
                  <option value="Casamento">Casamento</option>
                  <option value="15 anos">15 anos</option>
                  <option value="Formatura">Formatura</option>
                  <option value="Corporativo">Corporativo</option>
                  <option value="Outros">Outros</option>
                </select>
              </div>

              <div className="col">
                <label htmlFor="numero_convidados" className="block text-left">Número de convidados</label>
                <input
                  type="number"
                  id="numero_convidados"
                  className="w-full p-2 mt-2 border border-gray-300 rounded"
                  placeholder="Número de convidados"
                  value={numeroConvidados}
                  onChange={(e) => setNumeroConvidados(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* Mensagem */}
            <div className="mb-4">
              <label htmlFor="mensagem" className="block text-left">Digite sua mensagem aqui</label>
              <textarea
                id="mensagem"
                className="w-full p-2 mt-2 border border-gray-300 rounded"
                placeholder="Sua mensagem"
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                required
              />
            </div>

            {/* Botão de envio */}
            <button
              type="submit"
              className="bg-laranja text-white px-6 py-2 rounded font-bold hover:opacity-90 transition-opacity"
            >
              Enviar
            </button>
          </form>
        </div>
      </section>
        
      {/* Rodapé */}
      <footer className="bg-slate-900 py-4">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4 gap-y-4">
          {/* Redes sociais */}
          <div className="social-links flex items-center">
            <a
              href="https://www.facebook.com/fotcabine"
              className="mx-3 text-white hover:text-orange-400"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-square"></i> Facebook
            </a>
            <a
              href="https://www.instagram.com/fotcabine/"
              className="mx-3 text-white hover:text-orange-400"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i> Instagram
            </a>
            <a
              href="https://wa.me/5521992801818?text=Ol%C3%A1%2C%20vim%20do%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%21"
              className="mx-3 text-white hover:text-orange-400"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i> WhatsApp
            </a>
          </div>

          {/* Direitos autorais */}
          <div className="copyright text-white text-sm">
            <p className="m-0">&copy; 2026 Fotocabine. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>

      {/* Botão Flutuante do WhatsApp */}
      <a
        href="https://wa.me/5521992801818?text=Ol%C3%A1%2C%20vim%20do%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%21"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </React.Fragment>
  );
}

export default App;